import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ConsumersService } from '../../../core/services/consumers.service';
import { SharedService } from '../../../shared/shared.service';
import { SweetAlertIcon } from '../../../shared/constants/enum';
import {
  FormArray,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Validations } from '../../../shared/constants/validations';
import { FeedBackService } from '../../../core/services/feedback.service';
import { LoaderService } from '../../../core/services/loader.service';
import { Helper } from '../../../core/helpers/helper';

@Component({
  selector: 'app-consumer-feedback',
  templateUrl: './rp-feedback.component.html',
  styleUrl: './rp-feedback.component.scss',
  standalone: false,
})
export class ConsumerFeedbackComponent {
  consumerFeedback: any;
  consumerFeedbackForm!: UntypedFormGroup;
  prifileValidations = Validations;
  submitted: boolean = false;
  userRole: any;
  constructor(
    private router: Router,
    private feedbackService: FeedBackService,
    private sharedService: SharedService,
    private modalService: BsModalService,
    private formBuilder: UntypedFormBuilder,
    private loaderService: LoaderService
  ) {
    this.consumerFeedback = this.formBuilder.group({
      feedbacks: ['', [Validators.required, Validators.minLength(2)]],
    });
    this.sharedService.getCurrentUser().subscribe((user) => {
      this.userRole = user?.currentUserRoleDetails?.role;
    });
  }

  get consumersFeedbackControls() {
    return this.consumerFeedback.controls;
  }
  closeModal() {
    this.modalService.hide();
  }

  ngOnInit() {}
  isonlyspaces: boolean = false;
  onSubmit() {
    //  this.loaderService.setLoading(true)
    this.submitted = true;
    console.log(this.consumerFeedback.get('feedbacks')?.value);
    //saveFeedback
    const feedbackValue = this.consumerFeedback.get('feedbacks')?.value || '';

    if (this.consumerFeedback.valid) {
      let payload = {
        description: this.consumerFeedback.get('feedbacks')?.value,
      };
      if (feedbackValue.trim() === '') {
        this.loaderService.setLoading(false);
        // Only spaces or completely empty
        this.isonlyspaces = true;
        console.log('Invalid: only spaces are not allowed');
        return;
      } else {
        this.isonlyspaces = false;
      }

      this.loaderService.setLoading(true);
      this.feedbackService.saveFeedback(payload, this.userRole).subscribe({
        next: (response) => {
          this.loaderService.setLoading(false);
          if (response.statusCode === 200) {
            this.sharedService.showMessageDialog(
              'Success',
              response.message,
              SweetAlertIcon.SUCCESS
            );
            this.modalService.hide();
          }
        },
        error: (err) => {
          this.loaderService.setLoading(false);
          this.sharedService.showMessageDialog(
            'Failure',
            err,
            SweetAlertIcon.ERROR
          );
        },
      });
    }
  }
}
